module.exports = __webpack_public_path__ + "static/media/girdhari_parmar_ji.10c21fb2.jpg";